import { useContext } from "react";

import { WordopolisContext } from "../contexts/wordopolis";

export const useWordopolis = () => {
  const context = useContext(WordopolisContext);
  if (!context) {
    throw new Error("useWordopolis must be used within a WordopolisContextProvider");
  }
  return context;
};
